import { Box, Container, Stack, Button, Typography, Grid } from '@mui/material';
import { dataProfesionales } from "../../data/data";
import imagenBackground from "../../assets/Membership/Network/img01.png";

const brandProfesionales = () => {
  return (
    <Box sx={{
      height: "auto",
      position: "relative",
      width: "100%",
      overflow: "visible",
      bgcolor: "#ffffff",
      padding: "20px 15px",
    }}>

      <Container sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        padding: "0",
        margin: "0",
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
      }}>

        <Box sx={{
          display: "flex",
          justifyContent: "center",
          mr: {xs: "0", sm: "16px"},
          flexDirection: {xs: "column", sm: "row"}
        }}>

          <Box sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}>

            <Box sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}>

              <Typography variant="h2"
                sx={{ 
                  margin: "0px",
                  lineHeight: "1.235",
                  textAlign: "left",
                  color: "rgb(25, 91, 224)",
                  fontWeight: "900",
                  width: {xs: "80%"},
                  fontSize: {xs:"20px", md: "22px"},
                }}>
                  Amplia red de profesionales de la salud
              </Typography>

              <Typography variant="h3"
                sx={{ 
                  margin: "8px 0px 0px",
                  lineHeight: "1.15",
                  textAlign: "justify",
                  color: "rgb(24, 36, 107)",
                  fontWeight: "500",
                  width: {xs: "80%"},
                  fontSize: {xs:"14px"},
                }}>
                  Con tu Membresía Salud365 usted y su familia tendrán acceso a un extenso catálogo de profesionales de la salud con costo de consulta preferencial.
              </Typography>
            </Box>

            <Box sx={{
              margin: {xs:"12px 0"},
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}>

              <Grid container  sx={{
                justifyContent: "center",
                maxWidth: {xs:"100%", sm:"90%"}
              }}>

                {dataProfesionales.map((item, index) => (
                <Grid item xs={6} key={index}
                  sx={{
                    margin: "0",
                  }}>
                  <Box sx={{
                    padding:{xs:"8px", sm:"24px"},
                  }}>
                    <Stack display="flex" flexDirection="row" textAlign="center">
                      <Box sx={{
                        margin: "0",
                        display: "flex",
                        justifyContent: "center",
                      }}>
                        <img src={item.icono} alt="icono" loading="lazy" width="100%" height="100%"/>
                      </Box>
                      
                      <Typography width="100%" textAlign="left" 
                      sx={{ 
                        fontSize: {xs: "12px", md: "17px"}, 
                        ml:"8px",
                        lineHeight: "1.43",
                        textAlign: "left",
                        display: "flex",
                        alignItems: "center",
                        color: "rgb(24, 36, 107)",
                      }}>
                        {item.texto}
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
                ))}

                {/* <Button
                  component="a"
                  className="anim-button"
                  href="https://drive.google.com/file/d/1XTqw6gCM-0a0rc3PzsAh9jmvBey_diQk/view?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    padding: '10px',
                    color: 'white',
                    borderRadius: '4px',
                    backgroundColor: "rgb(109, 219, 86)",
                    boxShadow: "rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px",
                    mt: "15px",
                    fontWeight: "700",
                  }}>
                  VER DIRECTORIO MÉDICO
                </Button> */}
              </Grid>
            </Box>
          </Box>

          <Box sx={{
            width: {xs:"50%", sm:"100%", md:"60%"},
            alignSelf: "center"
          }}>
            <Box
              component="img"
              src={imagenBackground}
              alt="imagen Benefits"
              loading="lazy"
              sx={{
                objectFit: "contain",
                height: {xs: "100%"},
                width: {xs: "100%"},
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default brandProfesionales;
